/* =========================================================
   Class Champions — cc-mobile-nav.js
   Phone menu drawer (768px and below). Markup: sections/header.liquid
   (#cc-mnav and the header's [data-cc-mnav-trigger] button).
   Styles: assets/cc-mobile-nav.css.

   - Opens from the menu button; closes from the close button, the backdrop,
     Escape, a link in the menu, and when the screen becomes desktop-wide.
   - While open: the page is locked (no background scroll), focus starts on the
     close button and stays inside the drawer; on close it returns to the button.
   - Groups (Shop by Age / Shop by Class): the button's aria-expanded is the
     only state; CSS shows or hides the child links from it.
   - Back/forward cache: a restored page always shows the menu closed.
   ========================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-cc-mnav]');
  var trigger = document.querySelector('[data-cc-mnav-trigger]');
  if (!root || !trigger || root.hasAttribute('data-cc-ready')) return;
  root.setAttribute('data-cc-ready', '');

  var panel = root.querySelector('[data-cc-mnav-panel]');
  var desktop = window.matchMedia('(min-width: 769px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SPEED = 260;   // matches --mnav-speed in cc-mobile-nav.css
  var hideTimer = 0;

  function isOpen() { return root.classList.contains('is-open'); }

  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button'),
      function (el) { return el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden'; }
    );
  }

  function open() {
    if (isOpen()) return;
    clearTimeout(hideTimer);
    root.hidden = false;
    document.documentElement.classList.add('cc-mnav-lock');
    trigger.setAttribute('aria-expanded', 'true');
    void panel.offsetWidth;   // start the slide from the off-screen position
    root.classList.add('is-open');
    document.addEventListener('keydown', onKeydown);
    var closeBtn = panel.querySelector('[data-cc-mnav-close]');
    (closeBtn || panel).focus({ preventScroll: true });
  }

  // instant: no slide-out (used when leaving the page or switching to desktop).
  function close(returnFocus, instant) {
    if (root.hidden) return;
    root.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onKeydown);
    clearTimeout(hideTimer);
    var finish = function () {
      root.hidden = true;
      document.documentElement.classList.remove('cc-mnav-lock');
    };
    if (instant || reducedMotion.matches) finish();
    else hideTimer = setTimeout(finish, SPEED);
    if (returnFocus) trigger.focus({ preventScroll: true });
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); panel.focus(); return; }
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  trigger.addEventListener('click', open);

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cc-mnav-close]')) { close(true); return; }
    var group = e.target.closest('[data-cc-mnav-group]');
    if (group) {
      group.setAttribute('aria-expanded', group.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      return;
    }
    if (e.target.closest('a[href]')) close(false, true);   // the page is about to change
  });

  function onViewportChange(e) { if (e.matches) close(false, true); }
  if (desktop.addEventListener) desktop.addEventListener('change', onViewportChange);
  else if (desktop.addListener) desktop.addListener(onViewportChange);

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) close(false, true);
  });
})();
